module.exports = __webpack_public_path__ + "img/graduated-4-min.c8f338ec.png";